<div
  id="map"
  style="height: 100%; width: 100%"
></div>
<div #locateMeIcon>
  <div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <common-icon-dp-icon
      [icon]="'locate-me'"
      [iconSize]="'24'"
    ></common-icon-dp-icon>
  </div>
</div>
